import { HorizontalContainer } from '@american-autonomy/ag-ui';

import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ButtonSubtext: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <HorizontalContainer className={`${className} ${styles.buttonSubtext}`} testId={testId}>
        <LabelText className={styles.labelText} text={text} />
    </HorizontalContainer>
);

export default ButtonSubtext;
